import _get from "lodash/get";
import styled, { css } from 'styled-components';
import { rem } from 'polished';
import { typographyTheme } from '~typography';
import formTheme from '../../styles/formTheme';
var Textarea = styled.textarea.withConfig({
  displayName: "Textarea",
  componentId: "sc-1vcxaxl-0"
})(["appearance:none;background-color:transparent;border-color:", ";border-style:solid;border-width:0 0 1px;color:", ";display:block;font-family:", ";font-size:", ";margin-top:", ";outline:0;padding:", " ", " ", ";resize:none;width:100%;", " ", " ", ""], function (_ref) {
  var theme = _ref.theme,
      skin = _ref.skin;
  return _get(theme, "form.input." + skin + ".borderColor", formTheme.form.input[skin].borderColor);
}, function (_ref2) {
  var theme = _ref2.theme,
      skin = _ref2.skin;
  return _get(theme, "form.input." + skin + ".color", formTheme.form.input[skin].color);
}, function (_ref3) {
  var theme = _ref3.theme;
  return _get(theme, 'typography.base.fontFamily', typographyTheme.typography.base.fontFamily);
}, function (_ref4) {
  var theme = _ref4.theme;
  return rem(_get(theme, 'form.input.fontSize', formTheme.form.input.fontSize));
}, rem(20), rem(4), rem(12), rem(8), function (_ref5) {
  var readOnly = _ref5.readOnly;
  return readOnly && css(["border-color:transparent;"]);
}, function (_ref6) {
  var disabled = _ref6.disabled,
      skin = _ref6.skin,
      theme = _ref6.theme;
  return disabled && css(["border-bottom-style:dotted;border-color:", ";color:", ";cursor:not-allowed;"], _get(theme, "form.input." + skin + ".colorDisabled", formTheme.form.input[skin].colorDisabled), _get(theme, "form.input." + skin + ".colorDisabled", formTheme.form.input[skin].colorDisabled));
}, function (_ref7) {
  var hideLabel = _ref7.hideLabel;
  return hideLabel && css(["margin-top:0;padding-top:", ";"], rem(12));
});
export default Textarea;